import _ from 'lodash'
import costs from './costs'
import combine from './combine'

export default (form) => (
  _.map(combine(costs(form)), ({ value, ...rest }) => ({
    value: _.round(value),
    ...rest
  }))
)
